<template>
    <div class="address-list-container">
        <van-sticky>
            <van-notice-bar left-icon="info-o"
                >已添加地址（{{ addressList.length }}/5）</van-notice-bar
            >
        </van-sticky>
        <div class="content">
            <van-empty v-if="0 === addressList.length" description="暂无地址" />
            <ul v-for="(item, index) in addressList" :key="index">
                <section @click="onEdit(item)">
                    <li>
                        <span class="name">{{ item.name || "" }}</span>
                        <span class="phone">{{ item.phone || "" }}</span>
                        <span class="default" v-if="item.isDefault"
                            ><van-tag type="success">默认</van-tag></span
                        >
                    </li>
                    <li class="address">
                        {{ item.address || "" }} {{ item.addressDetail || "" }}
                    </li>
                </section>
                <li class="del" @click="onDelete(item.id)">
                    <van-icon name="delete" />
                </li>
            </ul>
        </div>
        <div class="bottom">
            <van-button
                round
                block
                @click="onAdd()"
                size="small"
                type="primary"
                native-type="submit"
                >新增地址</van-button
            >
        </div>
        <!-- <van-address-list v-model="chosenAddressId" :list="addressList" default-tag-text="默认" @add="onAdd" @edit="onEdit" /> -->
    </div>
</template>

<script>
import manageApi from '@/api/manageApi';

export default {
    inject: ['reload'],
    data() {
        return {
            addressList: []
        };
    },
    created() {
        this.initAddressList();
        sessionStorage.clear();
    },
    mounted() {
        setTimeout(() => {
            const { $toast } = this;
            $toast.clear();
        }, 1000)
    },
    methods: {
        initAddressList() {
            let organId = this.organInfo.organCode;
            manageApi
                .queryUserAddress(organId)
                .then(res => {
                    const data = res.data;
                    this.addressList = data;
                })
                .catch(() => { })
                .finally(() => { });
        },
        onAdd() {
            const { $router, $toast, addressList } = this;
            if (5 <= addressList.length) {
                $toast('最多只能添加5个地址');
                return;
            }
            $router.push({
                path: '/manage/address_manage'
            });
        },
        onEdit(item, index) {
            const { $router } = this;
            $router.push({
                path: '/manage/address_manage',
                query: {
                    id: item.id
                }
            });
        },
        onDelete(id) {
            const { $toast, $router, $dialog } = this;
            $dialog
                .confirm({
                    message: '确认删除该地址吗？'
                })
                .then(() => {
                    manageApi
                        .delUserAddress(id)
                        .then(res => {
                            const data = res.data;
                            this.addressList = data;
                            $toast('删除成功');
                        })
                        .catch(() => { })
                        .finally(() => { });
                })
                .catch(() => {
                    // on cancel
                });
        }
    },
    computed: {
        organInfo() {
            return this.$hdk.data(this.$setter.organInfo);
        }
    },
};
</script>

<style lang="less" scoped>
.address-list-container .content {
    font-size: 0.346666rem;
    color: #323233;
    padding-bottom: 1.333333rem;
}

.address-list-container .content ul {
    background-color: white;
    margin: 0.4rem;
    padding: 0.266666rem 1.5rem 0.266666rem 0.4rem;
    border-radius: 0.2rem;
    position: relative;
}
.address-list-container .content li {
    line-height: 0.766666rem;
    word-wrap: break-word;
}
.content ul span {
    margin-right: 0.133333rem;
}
.content .name,
.phone {
    font-size: 0.426666rem;
}
.content .del {
    position: absolute;
    font-size: 0.48rem;
    right: 0.533333rem;
    top: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
}

.address-list-container .bottom {
    position: fixed;
    bottom: 0;
    padding: 0.213333rem 0.48rem;
    background-color: @white-color;
    left: 0;
    right: 0;
    height: 0.933333rem;
    box-shadow: 0 -0.06rem 0.1rem 0.04rem rgba(0, 0, 0, 0.03);
    display: flex;
    align-items: center;
}
</style>